<template>
  <div class="simpleBroad">
    <div class="row" v-for="(item, index) in area" :key="index">
      <div class="col-md-3" v-for="(shife, index) in item" :key="index">
        <el-card class="box-card outer-frame">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px">
              {{ shife.name }}排班站 ({{ shife.driverInfo.length }})
            </span>
          </div>
          <div v-for="(driver, index) in shife.driverInfo" :key="index">
            <el-row :gutter="8">
              <el-col
                :span="22"
                class="iner-frame"
                @click.native="_clickDrvierInfo(driver, shife.name)"
              >
                <span class="fontSize20" style="color: red">
                  ({{ scheduledState(driver, index) }})
                </span>
                <span class="fontSize20">{{ driver.callNumber }},</span>
                <span class="fontSize20">
                  時間:{{ transferDate(driver.shiftUpdatedTime) }}
                </span>
                <span class="fontSize20">備註:{{ driver.driverNote }}</span>
              </el-col>
              <el-col :span="2" style="margin-top: 8px">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-close"
                  circle
                  @click="removeShift(driver, shife.name)"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { constants } from 'fs'
import moment from 'moment'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
export default {
  props: ['shiftDriver'],
  data() {
    return {
      scheduling: true,
    }
  },
  methods: {
    transferDate(time) {
      return moment(time).format('MM-DD HH:mm:ss')
    },
    _clickDrvierInfo(value, shiftName) {
      /* console.log(value) */
      let info = {
        shiftName,
        callNumber: value.callNumber,
        account: value.account,
        shiftUpdatedTime: value.shiftUpdatedTime,
      }
      /* console.log('info', info) */
      this.$emit('driver-scheduled-info', info)
    },
    scheduledState(value, index) {
      // console.log(value)
      switch (value.state) {
        case 4:
          return index + 1
          break
        case 2:
          this.scheduling = false
          return '派遣中'
          break
        default:
          return '異常'
          break
      }
    },
    removeShift(info, shiftName) {
      if (confirm('是否要除班?')) {
        /* console.log(info) */
        info.shiftName = shiftName
        this.$emit('removeShift', info)
      }

      BehaviorRecorder.record(
        '點擊',
        '排班看板',
        `刪除排班<${info.shiftName}>` +
          `&&司機: ${info.callNumber}` +
          `&&排班時間: ${info.shiftUpdatedTime}`,
      )
    },
  },
  computed: {
    area() {
      /* console.log(this.shiftDriver) */
      let array = []
      let total = []
      let count = 0
      this.shiftDriver.sort(function (a, b) {
        return a.name > b.name ? 1 : -1
      })
      for (let i = 0; i < this.shiftDriver.length; i++) {
        count++
        array.push(this.shiftDriver[i])
        if (count === 4 || this.shiftDriver.length - i - 1 === 0) {
          total.push(array)
          array = []
          count = 0
          continue
        }
      }

      return total
    },
  },
}
</script>

<style scoped>
.outer-frame {
  /* border: solid 1px black; */
  height: 400px;
  margin-bottom: 10px;
  overflow-y: auto;
}
.iner-frame {
  border: solid 1px black;
  margin-top: 5px;
}
span {
  color: black;
}
.iner-frame:hover {
  background-color: #ffcccc;
}
</style>



// WEBPACK FOOTER //
// src/components/areaComponent/simpleBroad.vue